<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <!-- <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button> -->
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 messageBlock my-1" v-if="store.error.msg">
                <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
            </div>
            <!-- <div class=" col-12 messageBlock my-1" v-if="store.user.access_token && (!store.customerDetail.profileName ||store.customerDetail.profileName == '')">
                <p class="alert alert-danger">
                    In order to complete registration, please update display name.  
                </p>
            </div> -->
            <div class="col-12 mt-3">
                 <!-- <router-link class="d-flex align-items-center backBtn medium" to="/personal-details">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}}
                </router-link> -->
                <div class="counterStep text-end">
                    <p>{{$t('upload_image.text1')}}</p>
                </div>
            </div>
            <div class="col-12">
                <Form class="personalDetails" @submit="submit">
                <div class="mainTitle mb-2">
                    <h3 class="mb-3 clash">{{$t('upload_image.text2')}}<span class="bgTitle">{{store.customerDetail.firstName || ''}} {{store.customerDetail.lastName || ''}}</span></h3>
                    <p>{{$t('upload_image.text3')}}</p>
                </div>
                <div class="maxValue">
                    <div class="profilePicUpdate">
                        <!-- <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-4 medium">Public Profile</h4>
                            <p class="f-12 d-flex align-items-center mb-0">Please follow the Guidelines <vue-feather
                                    class="ms-1" size="14" type="alert-circle"></vue-feather>
                            </p>
                        </div> -->
                        <div class="position-relative d-inline-flex justify-content-center my-md-5 mb-4">
                            <img class ="rounded-circle objectPosition" width="160" height="160" :src="addfileImage(form.file)" v-if="form.name && store.customerDetail.imageUrl" />
                            <img class ="rounded-circle objectPosition" width="160" height="160" :src="addfileImage(form.file)" v-if="form.name && !store.customerDetail.imageUrl" />
                            <img class ="rounded-circle objectPosition" width="160" height="160" :src="store.customerDetail.imageUrl+'?'+getTime()" v-if="store.customerDetail.imageUrl && form.name == ''">
                            <h2 v-if="!form.file.name && !store.customerDetail.imageUrl && store.customerDetail.firstName && store.customerDetail.lastName">{{store.customerDetail.firstName.charAt(0)}}{{store.customerDetail.lastName.charAt(0)}}</h2>
                            <h2 v-if="!form.file.name && !store.customerDetail.imageUrl && !store.customerDetail.firstName && !store.customerDetail.lastName">ZT</h2>
                        <!--  <p v-if="form.file.name && !store.customerDetail.imageUrl">{{form.file.name}}</p> -->
                            <!-- <span @click="clearDoc()" v-if="form.name && !store.customerDetail.imageUrl"><vue-feather type="x"></vue-feather></span> -->
                            <Field type="file" name="File" accept="image/*,application/pdf" @change="setImage($event)" class="file-upload-input"  id="fileUpload" ref="document" style="display: none;" />
                            <a href="javascript:void(0)" class="position-absolute editable" @click="uploadDoc()">
                                <vue-feather size="20" type="camera"></vue-feather>
                            </a>
                        </div>
                    </div>
                    <float-label class="form-group">
                        <Field
                        class="form-control"
                        name="Display name"
                        :placeholder="$t('upload_image.text4')"
                        v-model="form.username"
                        />
                        <ErrorMessage class="text-danger" name="Display name" />
                    </float-label>
                    <div class="buttonElement mb-3">
                        <button type="submit" class="grd_btn full_size"> {{$t('upload_image.text5')}}</button>
                         <!-- <button type="submit" class="grd_btn"> Skip</button> -->
                    </div>
                </div>
            </Form>
            </div>
        </div>
    </section>
</template>
<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
import { useToast } from "vue-toastification";
export default {
    setup() {
        const store = useMainStore();
        const toast = useToast();
        return { store,toast };
    },
    data(){
        return {
            form : {
                file : {},
                name : '',
                uploadedImage : '',
                username : ''
            }
        }
    },
    components: {
        FloatLabel,
        Form,
        Field,
        ErrorMessage,
    },
    methods:{
        clearDoc(){
            document.getElementById("fileUpload").value = ''
            this.form.file = {}
            this.form.name = ''
        },
        uploadDoc(){
            document.getElementById("fileUpload").click()
        },
        submit(){
            let formData = {};
            formData['name'] = this.form.username
            this.store.userNamePUT(formData,true,this).then((response)=>{
                if(Object.keys(response).length){
                    if(this.form.name){
                        this.uploadImage()
                    }else{
                        this.$router.replace('/complete-registration')
                    }
                }
            })
        },
        uploadImage(){
           let formData = new FormData();
           if(this.form.file.name){
                formData.append('avatar',this.form.file)
           }
           this.store.uploadUserImage(formData,true).then((response) =>{
            if(response === true){
                this.clearDoc()
                if(this.store.customerDetail.emailVerified && this.store.customerDetail.phoneVerified){
                    this.$router.replace('/complete-registration')
                }
                this.getUserDetail()
            }
           })
        }, 
        getUserDetail(){
            this.store.callCustomerDetail({},true,this,'')     
        },
        getTime(){
            var date = new Date();
            return date.getTime()
        },
        addfileImage(file){
            return URL.createObjectURL(file);
        },
        setImage(event){
            if(event.target.files[0]){
                let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic)$/i;
                if(!allowedExtensions.test(event.target.files[0]?.name)){
                    this.toast.error(this.$t('upload_image.text6'));
                }else{
                    this.form.file = event.target.files[0]
                    this.form.name = this.form.file.name
                }
            }
        }
    },
    mounted(){
         if(Object.keys(this.store.customerDetail).length){
            if(this.store.customerDetail.profileName){
             this.form.username = (this.store.customerDetail.profileName) ? this.store.customerDetail.profileName : ''
            }else{
                if(this.store.customerDetail.firstName && this.store.customerDetail.lastName){
                    this.form.username = `${this.store.customerDetail.firstName} ${this.store.customerDetail.lastName}`
                }else{
                    this.form.username = (this.store.customerDetail.firstName) ? this.store.customerDetail.firstName : ''
                }
            }
         }
    },
}
</script>